var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth"},[_c('component-layout',{attrs:{"type":this.type},on:{"toggle-type":_vm.toggle}}),_c('componentModal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }